import * as React from 'react';
import { LoadingIndicator, InclinationChart, PVASelect, PVAContentBody, PVAContentHeader, LoadingIndicatorMini, PVABadge } from '../../../components';
import { ReportType } from '../../../enums';
import { ReportDataService } from '../../../services';
import { } from '../../../models';
import { BaseRouteProps } from '../../../interfaces';
import { FilterStore, UserStore } from '../../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import './InteractionReport.css';

interface InteractionReportBlockState {
    organizationId: number;
    surveyId: number;
    userId?: number;
    selectedUserData: any;
    reportType: ReportType;
    sticky: boolean;
    stickySize: number;
    miniLoader: boolean;
    pdfLoader: boolean;
    open: boolean;
}

interface InteractionReportBlockProps extends BaseRouteProps<{}> {
    FilterStore?: FilterStore;
    UserStore?: UserStore;
    showDropDown: boolean;
}

@inject('FilterStore', 'UserStore') @observer
export class InteractionReportBlock extends React.Component<InteractionReportBlockProps, InteractionReportBlockState> {
    // private userDataService = new UserDataService(this.props.notificationService);
    private reportDataService = new ReportDataService(this.props.notificationService);
    private banner: any;

    constructor(props: InteractionReportBlockProps) {
        super(props);

        this.state = {
            selectedUserData: null,
            reportType: ReportType.Standard,
            organizationId: 0,
            surveyId: 0,
            sticky: false,
            stickySize: 0,
            userId: undefined,
            miniLoader: false,
            pdfLoader: false,
            open: false
        };
    }

    @computed get userId() {
        return this.props.UserStore!.userInfo.id;
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    @computed get users() {
        if (this.props.FilterStore && this.props.FilterStore.users) {
            return this.props.FilterStore.users;
        }
        return [];
    }

    @computed get userPermissions() {
        return this.props.UserStore!.userInfo.userPermissions;
    }

    @computed get surveyReportType() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType;
        }
        return null;
    }

    private updateSurvey() {
        if (!this.survey || !this.surveyVersion) {
            this.setState({
                miniLoader: false
            });
            return;
        }

        var userId = this.state.userId;
        // if (!userId && this.props.FilterStore!.interactionReportUserId) {
        //     userId = this.props.FilterStore!.interactionReportUserId;
        //     this.setState({
        //         userId: userId,
        //         loading: false
        //     });
        // }

        if (userId) {
            this.reportDataService.getManagersReportData(this.surveyVersion.id, userId).then((reportData) => {
                this.setState({
                    selectedUserData: reportData,
                    miniLoader: false
                });
                this.forceUpdate();
            });
        } else {            
            this.props.FilterStore!.interactionReportUserId = undefined;
            this.setState({
                selectedUserData: null,
                miniLoader: false
            });
        }
    }

    private update() {
        if (!this.props.showDropDown) {
            if (this.state.userId !== this.userId) {
                this.setState(
                    {
                        userId: this.userId,
                        miniLoader: true
                    },
                    this.updateSurvey);
            }

            if (this.organization && this.organization.id !== this.state.organizationId) {
                this.setState({
                    organizationId: this.organization.id
                });
            }

            if (this.survey && this.survey.id !== this.state.surveyId) {
                this.setState(
                    {
                        surveyId: this.survey.id,
                        miniLoader: true
                    },
                    this.updateSurvey);
            }
        } else {

            if (this.organization && this.organization.id !== this.state.organizationId) {
                this.setState({
                    organizationId: this.organization.id
                });

                this.updateSurvey();

                // this.userDataService.getByOrganizationLight(this.organization.id).then((users: User[]) => {
                //     this.setState({
                //         users: users
                //     });
                // });
            }

            if (this.survey && this.survey.id !== this.state.surveyId) {
                this.setState({
                    surveyId: this.survey.id
                });
                this.updateSurvey();
            }
        }
    }

    componentDidMount() {
        this.update();
    }

    componentWillReact() {
        this.update();
    }

    public submit(e: any) {
        var userId = Number(e.target.value);
        this.props.FilterStore!.interactionReportUserId = userId;

        this.setState(
            {
                userId: userId,
                miniLoader: true
            }, 
            this.updateSurvey);
    }

    handleScroll(event: any, t: any) {
        if (event.target.getAttribute('class') !== 'site-content-inner') {
            return;
        }

        var stick = this.state.stickySize;

        if (this.banner && this.state.stickySize === 0) {
            this.setState({
                stickySize: this.banner.offsetTop
            });
            stick = this.banner.offsetTop;
        }

        var sticky = stick;

        if (event.target.scrollTop >= sticky) {
            this.setState({
                sticky: true
            });
        } else {
            this.setState({
                sticky: false
            });
        }
    }

    private exportPDF() {
        if (this.state.selectedUserData && this.surveyVersion && this.state.userId) {
            this.setState({
                pdfLoader: true,
                open: false
            });
            this.reportDataService.getManagerReportDataPDF(this.surveyVersion.id, this.state.userId, 'InteractionReport', this.surveyReportType ? this.surveyReportType.id : undefined)
                .then(
                    (reportData: any) => {
                    this.setState(
                        {
                            pdfLoader: false
                        });
                },  (err: any) => {
                    this.setState(
                        {
                            pdfLoader: false
                        });
                });
        }
    }

    private ActionsButton(sticky: boolean) {
        return (
            <div className="btn-group dropdown">
                <button type="button" className="btn btn-primary"  onClick={(e) => this.setState({open: !this.state.open })}>
                    <span>Actions </span>
                    <span className="caret" />
                </button>
                <ul className={`action-menu dropdown-menu ${this.state.open ? 'open' : ''}`}>
                    <li className="options-header">Export Options</li>
                    <li className="options-entry" onClick={(e) => this.exportPDF()}>
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-save-file" /> <span> PDF Export</span>
                        </div>
                    </li>
                </ul>
        </div>);
    }

    private GetKeyOverride(key?: string, fallback?: any) {
        if (key && this.props.FilterStore) {
            return this.props.FilterStore.GetKeyOverride(key, fallback || '');
        }
        return fallback;
    }

    public render() {
        var defaultOptions = [{
            id: 0,
            value: '- Clear Selected -'
        }];

        return (
            <div className="site-content-inner" onScroll={(e) => this.handleScroll(e, this)}>
                {this.organization && <div id={`organization-${this.organization.id}`} />}
                {this.survey && <div id={`survey-${this.survey.id}`} />}
                {this.surveyReportType && <div id={`survey-${this.surveyReportType.id}`} />}

                <PVAContentHeader>
                    
                    <div className="row">
                        <div className="col-sm-10 col-md-8 col-xs-12">
                            <div className="title">
                                <span>
                                    {!this.props.showDropDown && this.GetKeyOverride('myInteractionReport', <span>MY PVA Interaction Report <span className="trademark">TM </span></span>)}
                                    {this.props.showDropDown && this.GetKeyOverride('interactionReport', <span>PVA Interaction Report <span className="trademark">TM </span></span>)}
                                    {this.props.showDropDown && <span className="light"> for </span>}
                                </span> 
                                {this.props.showDropDown && !this.state.sticky && <PVASelect defaultOptions={defaultOptions} options={this.users} selected={this.state.userId} onChange={(e: any) => this.submit(e)} />}
                                {!this.props.showDropDown && 
                                    <div className="select-box">
                                        {this.state.selectedUserData && <span>{this.state.selectedUserData.name}</span>}
                                        {this.state.selectedUserData && this.state.selectedUserData.style && <PVABadge style={this.state.selectedUserData.style.name} badge={this.state.selectedUserData.style.name[0]} />}
                                    </div>}
                                {this.state.miniLoader && <LoadingIndicatorMini />}
                            </div>
                        </div>
                        <div className="col-sm-2 col-md-4 text-right">
                            {this.ActionsButton(false)}
                        </div>
                    </div>
                </PVAContentHeader>

                <div ref={(e) => this.banner = e}>
                    <div className={'my-report-nav sticky-nav ' + (this.state.sticky ? 'sticky' : '')} >
                        <div className="inner-stick">
                            <div className="sticky-content">
                                <div className="title">
                                    <span>
                                        {!this.props.showDropDown && <span>My </span>}
                                        PVA Interaction Report <span className="trademark">TM </span>
                                        {this.props.showDropDown && <span className="light"> for  </span>}
                                    </span> 
                                    {this.props.showDropDown && <PVASelect defaultOptions={defaultOptions} options={this.users} selected={this.state.userId} onChange={(e: any) => this.submit(e)} />}
                                    {!this.props.showDropDown && 
                                        <div className="select-box">
                                            {this.state.selectedUserData && <span>{this.state.selectedUserData.name}</span>}
                                            {this.state.selectedUserData && this.state.selectedUserData.style && <PVABadge style={this.state.selectedUserData.style.name} badge={this.state.selectedUserData.style.name[0]} />}
                                        </div>}
                                    {this.state.miniLoader && <LoadingIndicatorMini />}
                                </div>
                            </div>
                            <div className="managers-report-header">
                                <div className="row">
                                    <div className="col-xs-8">
                                        <img src="/images/helpfullIcon.svg" />
                                        What helps an individual
                                    </div>
                                    <div className="col-xs-4">
                                        <img src="/images/hurtfullIcon.svg" />
                                        What hurts an individual
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>     

                {this.state.pdfLoader && <PVAContentBody><LoadingIndicator showPdfDescription={true} showBackground={true} showInPanel={true}/></PVAContentBody>}
                { !this.state.pdfLoader && <PVAContentBody>
                    {this.state.sticky && <div className="sticky-buffer" />}
                    {this.state.selectedUserData && this.state.selectedUserData.groups.length !== 0 &&
                        <div>
                            {this.state.selectedUserData.groups.filter((x: any) => {
                                if (!this.surveyReportType) {
                                    return true;
                                }
                                return x.surveyReportTypeID === this.surveyReportType.id;
                            }).map((dataGroup: any, dataGroupInd: number) => {
                                return <div className="row" key={dataGroupInd}>
                                    {
                                        dataGroup.data.map((entry: any, entryInd: number) => {
                                            return <div key={entryInd} className="content-row">
                                                <div className="row">
                                                    <div className="col-xs-4 helpfull" dangerouslySetInnerHTML={{ __html: entry.helpText }} />
                                                    <div className="col-xs-4 text-center">
                                                        <span className="group-title">{entry.displayName ? entry.displayName : entry.name}</span>
                                                    </div>
                                                    <div className="col-xs-4 hurtfull" dangerouslySetInnerHTML={{ __html: entry.hurtText }} />
                                                </div>
                                            </div>;
                                        })
                                    }
                                </div>;
                            })}
                        </div>
                    }
                    {this.props.showDropDown && (!this.state.selectedUserData || this.state.selectedUserData.groups.length === 0) &&
                        <div className="pva-welcome">
                            <img className="pva-style-image hidden-xs" src={`images/pvaStyleGraphic_0_Neutral.svg`} />
                            <span>Please select a user</span>
                        </div>
                    }
                </PVAContentBody>}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/interaction/InteractionReportBlock.tsx